import z from 'zod';

export const defaultDescriptionTemplate = `
## TL;DR
{High-level summary of the changes}

## Why we made these changes
{Reasoning for the changes}

## What changed?
{Detailed list of changes by file}

## Validation
{List of tests or validations performed}
`;

export const defaultOrgConfig: OrganizationConfig = {
  pulls: {
    description: {
      autoGenerate: true,
      template: defaultDescriptionTemplate,
    },
  },
  reviewAgent: {
    autoReview: true,
    syncCommentsToGitHub: true,
    commentTypes: {
      Logic: true,
      Style: true,
      Security: true,
      Performance: true,
      Question: false,
      Other: false,
    },
    commentSeverities: {
      Low: true,
      Medium: true,
      High: true,
    },
    autoApprove: {
      enabled: true,
      labels: ['minor-fix'],
      threshold: {
        low: undefined,
        medium: 1,
        high: 0,
        paths: [],
      },
    },
  },
};

export const commentTypesSchema = z.object({
  Logic: z.boolean().default(true),
  Style: z.boolean().default(true),
  Security: z.boolean().default(true),
  Performance: z.boolean().default(true),
  Question: z.boolean().default(false),
  Other: z.boolean().default(false),
});

export const commentSeveritiesSchema = z.object({
  Low: z.boolean().default(true),
  Medium: z.boolean().default(true),
  High: z.boolean().default(true),
});

export const reviewConfigSchema = z.object({
  autoReview: z.boolean().default(true),
  syncCommentsToGitHub: z.boolean().default(true),
  commentTypes: commentTypesSchema,
  commentSeverities: commentSeveritiesSchema,
  autoApprove: z.object({
    enabled: z.boolean().default(false),
    labels: z.array(z.string()).default([]),
    threshold: z.object({
      low: z.number().optional(),
      medium: z.number().default(1).optional(),
      high: z.number().default(0).optional(),
      paths: z.array(z.string()).default([]),
    }),
  }),
});

export const OrganizationConfigSchema = z.object({
  pulls: z.object({
    description: z.object({
      autoGenerate: z.boolean().default(true),
      template: z.string().default(defaultDescriptionTemplate),
    }),
  }),
  reviewAgent: reviewConfigSchema,
});

export type ReviewConfig = z.infer<typeof reviewConfigSchema>;
export type OrganizationConfig = z.infer<typeof OrganizationConfigSchema>;
